import * as React from 'react';
import { getValue, Row } from '../Row';
import { useSelector } from 'react-redux';
import { selectActiveCalltrackingPeriod } from '../../../../selectors/calltracking';

export const CalltrackingContainer = () => {
  const activePeriod = useSelector(selectActiveCalltrackingPeriod);

  if (!activePeriod || !activePeriod.price) {
    return null;
  }

  const { price, days } = activePeriod;

  const priceValue = getValue({ price, days });

  return <Row name="Защита номера" value={priceValue} />;
};
